import { createContext, useState } from "react";

const AcContext = createContext({
  consultingFieldsIds: [],
  activityFieldsIds: [],
});

export const AcProvider = ({ children }) => {
  const [consultingFieldsIds, setConsultingFieldsIds] = useState([]);
  const [activityFieldsIds, setActivityFieldsIds] = useState([]);

  const consultingFieldsIdsAction = (data) => {
    setConsultingFieldsIds(data);
  };

  const activityFieldsIdsAction = (data) => {
    setActivityFieldsIds(data);
  };

  return (
    <AcContext.Provider value={{consultingFieldsIds,activityFieldsIds,consultingFieldsIdsAction,activityFieldsIdsAction}}>
      {children}
    </AcContext.Provider>
  )
};

export default AcContext